(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("belasting", [], factory);
	else if(typeof exports === 'object')
		exports["belasting"] = factory();
	else
		root["belasting"] = factory();
})(self, () => {
return 